import React from 'react'
import { useSelector } from 'react-redux'
import { useAnalyticsEvent, useAnalyticsPageView, useAnalyticsTag } from '@chilecompra/react-kit/analytics'
import { Button, Typography, useViewport } from '@chilecompra/react-kit/components'
import { useLanguage, useLanguageFlags } from '@chilecompra/react-kit/i18n'
import ProtectByFeatures from '../../components/Security/ProtectByFeatures'
import {
  REACT_APP_MERCADO_PUBLICO_BASE_URL,
  REACT_APP_MERCADO_PUBLICO_PROVEEDOR_URL
} from '../../config/settings/environment'
import {
  Root,
  DesktopNavigation,
  MobileNavigation,
  Section,
  Title,
  Instructions,
  AccessInstructions,
  Username,
  Strong,
  Divided
} from './RegisterWizardComplete.styles'
import routes from '../../config/settings/routes'

/**
 * The RegisterWizardComplete' container.
 */
const RegisterWizardComplete = () => {
  const { business, guest, isRecoveryAdmin } = useSelector(state => state.registerWizard)
  const { language } = useLanguage()
  const { hasLanguage } = useLanguageFlags()
  const { size } = useViewport()
  const handleComplete = () => window.open(`${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Home`, '_top')

  const handleGoToPayment = () => {
    const URL = `${REACT_APP_MERCADO_PUBLICO_PROVEEDOR_URL}${routes.paymentFromRegister}?dni=${business.dni}&foreign=${hasLanguage}`

    window.open(URL, '_blank', 'noreferrer')
  }

  useAnalyticsEvent({ action: 'Finaliza asociar empresa', category: 'asociar-empresa' })
  useAnalyticsPageView(`/paso/${guest.isForeign ? '6' : '5'}/registro_completado`)
  useAnalyticsTag({ page: 'registro_fin' })

  return (
    <Root>
      <Section item>
        <Title>
          {!hasLanguage && !isRecoveryAdmin && '¡Has finalizado con éxito!'}
          {!hasLanguage && isRecoveryAdmin && 'Hemos asociado exitosamente esta empresa a tu perfil'}
          {hasLanguage && language('RegisterWizardComplete__title')}
        </Title>
      </Section>
      <Section item margin={hasLanguage ? '23px 0 0' : '23px 0 33px'} maxWidth="929px">
        <Instructions>
          {!hasLanguage &&
            !isRecoveryAdmin &&
            'Ya te encuentras registrado como usuario y has asociado exitosamente tu empresa a tu perfil. Ahora puedes ofertar en las oportunidades de negocio del Estado de Chile.'}
          {!hasLanguage &&
            isRecoveryAdmin &&
            'A partir de este momento tendrás privilegios de administración para esta empresa en Mercado Público. Este cambio se le notificará por correo a los administradores anteriores, de todas formas te recomendamos revisar y actualizar los roles de usuarios en tu escritorio.'}
          {hasLanguage && language('RegisterWizardComplete__description')}
        </Instructions>
      </Section>
      <ProtectByFeatures rule={features => features['com.seller/foreign.enrollment'] && hasLanguage}>
        <Section item margin="32px 0 33px">
          <AccessInstructions>{language('RegisterWizardComplete__instructions__1')}</AccessInstructions>
          <Username>{business.username}</Username>
          <Typography variant="body1">
            {language('RegisterWizardComplete__instructions__2')}
            <Strong>{guest.email}</Strong>
          </Typography>
        </Section>
      </ProtectByFeatures>
      {hasLanguage && (
        <>
          <Divided margin="58px 0 38px" width={size.isTiny ? '107%' : '90%'} />
          <Section item xs={12} md={6} lg={11}>
            <Instructions>{hasLanguage && language('RegisterWizardComplete__affidavit_subtitle')}</Instructions>
            <Typography variant="body1" color="black1" margin="15px 0 0">
              {hasLanguage && language('RegisterWizardComplete__affidavit_description')}
            </Typography>
          </Section>
          <Section item>
            <Button color="primary" margin="32px 0" onClick={handleGoToPayment} variant="outlined">
              Ir a pagar acreditación
            </Button>
          </Section>
        </>
      )}
      {!size.isTiny && (
        <Section container margin="52px 0 0 0">
          <DesktopNavigation>
            <Button color="primary" type="button" width="265px" onClick={handleComplete}>
              {!hasLanguage && 'Ir a Mercado Público'}
              {hasLanguage && language('RegisterWizardComplete__desktopButton')}
            </Button>
          </DesktopNavigation>
        </Section>
      )}
      {size.isTiny && (
        <MobileNavigation>
          <Button color="primary" type="button" width="90%" onClick={handleComplete}>
            {!hasLanguage && 'Ir a Mercado Público'}
            {hasLanguage && language('RegisterWizardComplete__desktopButton')}
          </Button>
        </MobileNavigation>
      )}
    </Root>
  )
}

export default RegisterWizardComplete
